<app-paineis-selecao-checkboxes
  [itensEsquerda]="itensEsquerda"
  [itensDireita]="itensDireita"
  tituloEsquerda="Usuários"
  labelColunaEsquerda="Login"
  tituloSemSelecao="Selecione um usuário"
  [tituloDireita]="tituloDireita"
  mensagemSemSelecao="Selecione um usuário na lista ao lado para editar seus papéis."
  labelAcaoExtra="Novo Papel"
  [salvando]="salvando"
  (itemSelecionado)="onItemSelecionado($event)"
  (toggleItem)="onToggleItem($event)"
  (salvarClick)="onSalvar($event)"
  (acaoExtraClick)="abrirCriarPapelDialog()">
</app-paineis-selecao-checkboxes>
